import React, { forwardRef } from "react";
import writtenNumber from "written-number";
import {InvoiceData } from "./Printtype"

const clp = (n: number) =>
  new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0,
  }).format(Math.round(n || 0));

const numeroEnLetras = (n: number) => {
  const txt = writtenNumber(Math.round(n || 0), { lang: "es" });
  return txt.charAt(0).toUpperCase() + txt.slice(1);
};

const money = (n: number) =>
  new Intl.NumberFormat("es-CL", { maximumFractionDigits: 0 }).format(
    Math.round(n || 0)
  );

const css = `
@media print {
  body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
:root{
  --accent: #e53935;
  --ink: #000;
}

/* -------- Página -------- */
.invoice-page{
  width:210mm; min-height:297mm;
  padding:12mm 12mm 14mm;
  margin:0 auto; background:#fff;
  box-sizing:border-box; position:relative;
  page-break-after: always;
  break-after: page;
}

/* marca de agua opcional (logo) */
.invoice-page::after{
  content:""; position:absolute; inset:0;
  background-repeat:no-repeat; background-position:center 55%;
  background-size:40%; background-image:var(--wm, none);
  opacity:.18; pointer-events:none;
}

/* Espacio reservado para el pie (varía por tipo) */
.is-normal { --footer-h: 28mm; }
.is-cedible{ --footer-h: 48mm; }

.content{
  /* Reserva el alto del pie para que no lo empuje */
  padding-bottom: var(--footer-h);
}

/* -------- Header -------- */
.header{
  display:grid;
  grid-template-columns: 2fr 140px 260px;  
  gap:16px;
  align-items:stretch;
  margin-bottom:8px;
}
.header:not(.has-bar){ grid-template-columns: 1fr 280px; }

/* barcode superior (1D) */
.barbox{
  display:flex; align-items:flex-end; justify-content:center;
  padding: 0 0 6px; height: 100%;
}
.barbox img{ height:28px; width:100%; object-fit:contain; image-rendering: pixelated; }

.brand{ display:flex; flex-direction:column; gap:6px; align-items:flex-start; }
:root{ --logo-max-w: 420px; --logo-h: 100px; }
.brand .logo{ width: min(100%, var(--logo-max-w)); height: var(--logo-h); }
.brand .logo img{ display:block; width:100%; height:100%; object-fit:contain; }
.brand .info .name{ font-weight:900; text-shadow: 0 0 1px #000; font-size:13px; color:var(--ink); }
.brand .info .lines{ font-size:11px; line-height:1.25; color:var(--ink); }

.docbox{
  border:3px solid var(--accent);
  color:var(--accent);
  text-align:center;
  padding:14px 10px;
  border-radius:4px;
  text-transform:uppercase;
  min-height: 140px;
  display:flex; flex-direction:column; justify-content:space-between; gap:6px;
}
.docbox .rut{ font-weight:900; text-shadow: 0 0 1px #000; font-size:16px; }
.docbox .doctype{ font-weight:900; text-shadow: 0 0 1px #000; font-size:16px; margin:6px 0 2px; }
.docbox .folio{ font-weight:900; text-shadow: 0 0 1px #000; font-size:16px; }
.sii{ font-weight:900; text-shadow: 0 0 1px #000; text-align:center; font-size:12px; margin-top:2px; color:var(--accent);}

.issuedAt{ font-weight:900; text-shadow: 0 0 1px #000; text-align:right; font-size:12px; color:#000; margin:6px 0 8px; }

.docwrap{ display:flex; flex-direction:column; align-items:center; gap:8px; }

.top-barcode{ height:42px; width:220px; object-fit:contain; image-rendering: pixelated; }

/* -------- Cliente + Comerciales -------- */
.cc-box{ border:1px solid #000; border-radius:2px; padding:8px; margin-bottom:10px; }
.cc-grid{ display:grid; grid-template-columns:1fr 1fr; gap:10px; }
.kv{ display:grid; grid-template-columns:130px 1fr; font-size:12px; row-gap:5px; }
.kv .k{ color:#000; font-weight:900; text-shadow: 0 0 1px #000; }
.kv .v{ color:#000; }

/* -------- Tabla de ítems -------- */
.table{ width:100%; border-collapse:separate; border-spacing:0; font-size:12px; }
.table th,.table td{ padding:6px 8px; border:none; color:#000; background:transparent; }
.table thead th{ font-weight:900; text-shadow: 0 0 1px #000; border-bottom:2px solid #000; }
.table tbody td{ border-bottom:1px solid #e5e5e5; }
.table tbody tr:last-child td{ border-bottom:none; }
.center{text-align:center;} .right{text-align:right;}

/* -------- Pie -------- */
.bottom{
  display:grid;
  grid-template-columns: 1fr 335px;  
  gap:18px; margin-top:18px; align-items:start;
  /* no forzar avoid aquí; si no cabe, que parta sólo el contenido interno */
}
.son{ font-size:12px; color:#000; margin-bottom:6px; }
.stamp{ height:160px; display:flex; align-items:center; justify-content:center; overflow:hidden; }
.stamp img{ width:100%; height:100%; object-fit:contain; image-rendering: pixelated; }
.stamp-caption{ font-size:10px; color:#444; text-align:center; margin-top:6px; }

.totals-box{ border:none; }
.totals-row{ display:grid; grid-template-columns:auto auto; column-gap:18px; padding:4px 0; font-size:12px; width:80%; }
.grp{ display:grid; align-items:center; column-gap:6px; border-bottom:1px solid #000; padding:4px 8px 4px 0; }
.grp-left{  grid-template-columns:70px 10px 58px; }
.grp-right{ grid-template-columns:70px 10px 58px; }
.t-label{ color:#000; white-space:normal; }
.t-currency{ text-align:center; }
.t-value{ text-align:right; padding-right:1px; }
.t-strong .grp .t-label, .t-strong .grp .t-value{ font-weight:800; }

.cancel-line{ font-size:12px; margin-top:8px; }
.cancel-underline{ display:inline-block; width:210px; border-bottom:1px solid #000; transform:translateY(-1px); }

.obs-box{ margin-top:6px; border:1px solid #000; height:78px; padding:6px; font-size:12px; }
.obs-title{ font-weight:700; margin-bottom:4px; }

/* Footer (leyendas) */
.footer-minis{ display:flex; justify-content:space-between; font-size:10px; color:#000; margin-top:8px; }
.footer-minis .cedible-tag{ font-weight:900; font-size:16px; }

/* Pie anclado */
.footer-block{
  position:absolute;
  left:12mm;
  right:12mm;
  bottom:14mm;
  break-inside: avoid;
}

/* Bloque de aceptación CEDIBLE */
.ack{ margin-top:8px; border:1px solid #000; padding:8px 10px; font-size:12px; }
.ack-grid{ display:grid; grid-template-columns: 1fr 1fr 1fr; column-gap:16px; row-gap:8px; align-items:center; }
.ack-line{ display:flex; gap:8px; align-items:center; }
.ack-line .lbl{ font-weight:700; }
.ack-underline{ flex:1; border-bottom:1px solid #000; height:1px; }
.ack-note{ font-size:11px; margin-top:6px; }
`;

type Props = { data: InvoiceData };

export const InvoiceA4 = forwardRef<HTMLDivElement, Props>(({ data }, ref) => {
  const {
    docType, folio, siiOffice, issuedAt,
    company, client, commercial, items, totals,
    barcodeSrc, observation,
  } = data;

  const wmStyle = company.logoUrl
    ? ({ ["--wm" as any]: `url(${company.logoUrl})` } as React.CSSProperties)
    : undefined;

  const Header = () => (
    <div className={`header ${data.headerBarcodeSrc ? "has-bar" : ""}`}>
      <div className="brand">
        <div className="logo">
          {company.logoUrl
            ? <img src={company.logoUrl} alt="logo" />
            : <div style={{ width: "100%", height: "100%", background: "#eee" }} />
          }
        </div>
        <div className="info">
          <div className="name">{company.name}</div>
          <div className="lines">
            {company.giro && <div>{company.giro}</div>}
            {company.addressLines.map((l, i) => <div key={i}>{l}</div>)}
            {company.website && <div>{company.website}</div>}
            {company.phones && <div>Fonos: {company.phones}</div>}
          </div>
        </div>
      </div>

      {data.headerBarcodeSrc && (
        <div className="barbox">
          <img src={data.headerBarcodeSrc} alt="código de barras" />
        </div>
      )}

      <div>
        <div className="docbox">
          <div className="rut">R.U.T.: {company.rut}</div>
          <div className="doctype">{docType}</div>
          <div className="folio">N° {folio}</div>
        </div>
        <div className="sii">{siiOffice}</div>
      </div>
    </div>
  );

  const ClientCommercial = () => (
    <div className="cc-box">
      <div className="cc-grid">
        <div className="kv">
          <div className="k">Señor(es):</div><div className="v">{client.name}</div>
          <div className="k">R.U.T.:</div><div className="v">{client.rut}</div>
          <div className="k">Giro:</div><div className="v">{client.giro}</div>
          <div className="k">Dirección:</div><div className="v">{client.address}</div>
          <div className="k">Comuna:</div><div className="v">{client.comuna}</div>
          <div className="k">Ciudad:</div><div className="v">{client.ciudad}</div>
        </div>

        <div className="kv">
          <div className="k"></div><div className="v">{commercial.sellerRut}</div>
          <div className="k">Condición de Venta:</div><div className="v">{commercial.paymentCondition}</div>
          {commercial.due && (<><div className="k">Vencimiento:</div><div className="v">{commercial.due}</div></>)}
          {commercial.salesNote && (<><div className="k">Nota de Venta:</div><div className="v">{commercial.salesNote}</div></>)}
          {commercial.quotation && (<><div className="k">Cotización:</div><div className="v">{commercial.quotation}</div></>)}
          <div className="k">Teléfono:</div><div className="v">{commercial.phone}</div>
          <div className="k">Hora:</div><div className="v">{commercial.hour}</div>
          <div className="k">N° Interno:</div><div className="v">{commercial.internalNumber}</div>
          <div className="k">Orden de Compra:</div><div className="v">{commercial.purchaseOrder}</div>
        </div>
      </div>
    </div>
  );

  const ItemsTable: React.FC<{ isCedible?: boolean }> = ({ isCedible }) => (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th className="center" style={{ width: 40 }}>Item</th>
            <th className="center" style={{ width: 90 }}>Código</th>
            <th>Descripción</th>
            <th className="center" style={{ width: 80 }}>Cantidad</th>
            <th className="right" style={{ width: 100 }}>Precio Unit.</th>
            <th className="right" style={{ width: 100 }}>Descuento($)</th>
            <th className="right" style={{ width: 110 }}>Valor</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it, i) => (
            <tr key={i}>
              <td className="center">{it.item}</td>
              <td className="center">{it.code ?? ""}</td>
              <td>{it.description}</td>
              <td className="center">
                {it.quantity.toLocaleString("es-CL")}
                {it.unit ? ` ${it.unit}` : ""}
              </td>
              <td className="right">{clp(it.unitPrice)}</td>
              <td className="right">{clp(it.discount ?? 0)}</td>
              <td className="right">{clp(it.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const Footer = (isCedible: boolean) => (
    <div className="footer-block">
      {/* Pie: SON + timbre + totales/obs */}
      <div className="bottom">
        {/* Izquierda */}
        <div>
          <div className="son">SON: {numeroEnLetras(totals.total)}</div>
          <div className="stamp">{barcodeSrc && <img src={barcodeSrc} alt="timbre electrónico" />}</div>
          <div className="stamp-caption">
            Timbre Electrónico S.I.I.<br />Verifique Documento: http://www.sii.cl
          </div>
        </div>

        {/* Derecha */}
        <div>
          <div className="totals-box">
            <div className="totals-row">
              <div className="grp grp-left">
                <div className="t-label">Exento</div><div className="t-currency">$</div><div className="t-value">{money(totals.exempt)}</div>
              </div>
              <div className="grp grp-right">
                <div className="t-label">NETO</div><div className="t-currency">$</div><div className="t-value">{money(totals.net)}</div>
              </div>
            </div>

            <div className="totals-row">
              <div className="grp grp-left">
                <div className="t-label">Descuento</div><div className="t-currency">$</div><div className="t-value">{money(totals.discount)}</div>
              </div>
              <div className="grp grp-right">
                <div className="t-label"><span>19% I.V.A.</span></div>
                <div className="t-currency">$</div><div className="t-value">{money(totals.tax)}</div>
              </div>
            </div>

            <div className="totals-row">
              <div className="grp grp-left">
                <div className="t-label">Recargo</div><div className="t-currency">$</div><div className="t-value">{money(0)}</div>
              </div>
              <div className="grp grp-right">
                <div className="t-label">TOTAL</div><div className="t-currency">$</div><div className="t-value">{money(totals.total)}</div>
              </div>
            </div>
          </div>

          <div className="cancel-line">
            Cancelado por: <span className="cancel-underline">&nbsp;</span>
          </div>

          <div className="obs-box">
            <div className="obs-title">Observaciones:</div>
            {observation ?? ""}
          </div>
        </div>
      </div>

      {/* Bloque de recepción SOLO en CEDIBLE */}
      {isCedible && (
        <div className="ack">
          <div className="ack-grid">
            <div className="ack-line"><span className="lbl">Nombre:</span><span className="ack-underline" /></div>
            <div className="ack-line"><span className="lbl">Rut:</span><span className="ack-underline" /></div>
            <div className="ack-line"><span className="lbl">Firma:</span><span className="ack-underline" /></div>

            <div className="ack-line"><span className="lbl">Recinto:</span><span className="ack-underline" /></div>
            <div className="ack-line"><span className="lbl">Fecha:</span><span className="ack-underline" /></div>
            <div></div>
          </div>
          <div className="ack-note">
            "El acuse de recibo que se declara en este acto, de acuerdo a lo dispuesto en la letra b) del art. 4º, y la letra c) del Art. 5º de la ley 19.983, acredita que la entrega de mercaderías o servicio(s) prestado(s) ha(n) sido recibido(s)".
          </div>
        </div>
      )}

      {/* Leyendas inferiores */}
      {!isCedible ? (
        <div className="footer-minis">
          <div><strong>Desarrollado por: www.erpsoftnet.cl</strong></div>
          <div>Implemente Facturación Electrónica 02 - 2947 9389 - www.erpsoftnet.cl</div>
        </div>
      ) : (
        <div className="footer-minis">
          <div><strong>DESARROLLADO POR: www.softnet.cl | Implemente Facturación Electrónica 2 2947 9389 - www.softnet.cl - acomercial@softnet.cl</strong></div>
          <div className="cedible-tag"><strong>CEDIBLE</strong></div>
        </div>
      )}
    </div>
  );

  const renderPage = (isCedible: boolean) => (
    <div className={`invoice-page ${isCedible ? 'is-cedible' : 'is-normal'}`} style={wmStyle}>
      <div className="content">
        <Header />
        <div className="issuedAt">{issuedAt}</div>
        <ClientCommercial />
        <ItemsTable isCedible={isCedible} />
      </div>
      {Footer(isCedible)}
    </div>
  );

  return (
    <div ref={ref as any}>
      <style>{css}</style>
      {renderPage(false)} {/* Página normal */}
      {renderPage(true)}  {/* Copia CEDIBLE */}
    </div>
  );
});

export default InvoiceA4;
